export class PledgeValidator {
    constructor(form, step, pledgeModule) {
      this.form = form;
      this.step = step;
      this.pledgeModule = pledgeModule;
  
      this.validatorPerStep = {
        1: this.validateStep1.bind(this),
        2: this.validateStep2.bind(this),
        3: this.validateStep3.bind(this),
        4: this.validateStep4.bind(this),
      };
    }

    get pageHeader() {
      return document.querySelector("header");
    }

    get pledgeHero() {
      return document.querySelector(".pledge-hero");
    }
  
    get messageContainerElement() {
      return this.form.querySelector(".pledge-form-message");
    }

    get messageElement() {
      return this.messageContainerElement.querySelector(".notification__message");
    }

    get message() {
      return this.messageElement.innerHTML || "";
    }

    set message(messageContent) {
      // Set message content and toggle visibility
      this.messageElement.innerHTML = messageContent;
      this.messageContainerElement.classList.toggle("d-block", Boolean(messageContent));
      this.messageContainerElement.classList.toggle("d-none", !Boolean(messageContent));
    } 

    validate() {
      // Loop through current steps and steps before it and run the validator attached to each step
      const isValid = Array.from({ length: this.step }, (_, i) => i + 1).every(step => this.validatorPerStep[step]());

      // Scroll to the message container if there is an error, otherwise scroll to the form top
      this.scrollContainer();

      return isValid;
    }
  
    validateField(field, condition) {
      if (condition) {
        field.classList.remove("is-invalid");
        return true;
      } else {
        field.classList.add("is-invalid");
        return false;
      }
    }
  
    isValidEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(email);
    }
  
    validateStep1() {
      let isValid = true;
  
      // Get form fields
      const organizationNameField = this.form.querySelector(
        "input[name='organization_name']"
      );
      const contactNameField = this.form.querySelector(
        "input[name='contact_name']"
      );
      const contactEmailField = this.form.querySelector(
        "input[name='contact_email']"
      );
      const pickedEvents = this.form.querySelectorAll(
        "input[name='pledge_domains[]']"
      );
  
      // Validate fields
      // Organization name might not exist if we're on the person form
      if (organizationNameField) {
        isValid &= this.validateField(
          organizationNameField,
          organizationNameField.value.trim() !== ""
        );
      }
      isValid &= this.validateField(
        contactNameField,
        contactNameField.value.trim() !== ""
      );
      isValid &= this.validateField(
        contactEmailField,
        this.isValidEmail(contactEmailField.value.trim())
      );
  
      // Check that at least one event checkbox is selected
      const isEventPicked = Array.from(pickedEvents).some(
        (checkbox) => checkbox.checked
      );
      pickedEvents.forEach((checkbox) => {
        isValid &= this.validateField(checkbox, isEventPicked);
      });
  
      // Display error message
      this.message = isValid ? null : "Controleer onderstaande velden.";
  
      return Boolean(isValid);
    }
  
    validateStep2() {
      return true;
    }
  
    validateStep3() {
      return true;
    }
  
    validateStep4() {
      const pledgeCheckboxes = this.form.querySelectorAll(
        "input[name='picked_pledges[]']"
      );
  
      // Ensure at least 2 pledges are checked
      const checkedPledgesCount = Array.from(pledgeCheckboxes).filter(
        (checkbox) => checkbox.checked
      ).length;
  
      const isValid = checkedPledgesCount >= 2;
  
      // Display error message if invalid
      this.message = isValid ? null : "Doe minimaal 2 beloftes.";
  
      // If validation fails, go back to first pledge step
      if (!isValid) {
        this.pledgeModule.currentStep = 2; 
      }
  
      return isValid;
    }

    scrollContainer() {
      if (!this.message) return;

      window.scrollTo({
        top: this.messageContainerElement.offsetTop - this.pageHeader.offsetHeight - 20,
        behavior: "smooth"
      });
    }
  }